export const DEFAULT_DASHBOARD_NODE_KEY = 'b14eabde-e1ef-4915-b84a-3f89eb63dabf';
